<template>
  <div class="inbox-listing" >
    <vue-perfect-scrollbar class="inbox-content-scroll">
      <v-flex class="d-custom-flex align-items-center justify-center h-100" v-if="loading">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-flex>
      <v-layout v-else row wrap px-2 pt-0 >
        <v-flex  v-for="(quoting, index) in cotizadores" :key="index" xs12 md4 lg4 xl4 sm6 >
          <CotizadorCard :quoting="quoting">
          </CotizadorCard>
        </v-flex>
      </v-layout>
    </vue-perfect-scrollbar>
  </div>
</template>
<script>
import CotizadorCard from "./CotizadorCard";
import { Waterfall, WaterfallItem } from "vue2-waterfall";
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import { i18n } from "@/main";

export default {
  computed: {
    ...mapGetters(["cotizadores", "loadingQuoting","agency"])
  },
  mounted() {
    this.$store.dispatch("cotizadores");
  },
  components: {
    CotizadorCard,
    Waterfall,
    WaterfallItem
  },
  watch: {
    loadingQuoting(val) {
      if (val) {
        this.$root.$emit("showLoading", "Cargando cotizadores");
      } else {
        this.$root.$emit("hideLoading");
      }
    },
    agency(val){
      this.$store.dispatch("cotizadores");
    }
  },
  data() {
    return {
      loading: false
    };
  }
};
</script>